module.exports = __webpack_public_path__ + "static/fonts/GroteskDemiBold.5f09133.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GroteskDemiBold.woff
// module id = aO4K
// module chunks = 0